export default "__VITE_ASSET__C0UtML45__"